<!-- eslint-disable -->
<template>
  <span>{{C_orgName}}</span>
</template>

<script>
/* eslint-disable */
export default {
  props: ["P_orgUid"],
  name: "OrgNameLabel",
  data() {
    return {
      DV_orgMetadata: {}
    }
  },
  mounted() {
    const CI = this;
    CI.DV_orgMetadata = window.G_web_gui_data.IV_org_metadata;
  },
  computed: {
    C_orgName() {
      const CI = this;

      if (CI.P_orgUid === null || CI.P_orgUid === undefined) {
        return "Loading...";
      }

      if (CI.P_orgUid in CI.DV_orgMetadata === false) {
        return "Loading...";
      }

      if (CI.DV_orgMetadata[CI.P_orgUid] === null || CI.DV_orgMetadata[CI.P_orgUid] === undefined) {
        return "Loading...";
      }

      if ('name' in CI.DV_orgMetadata[CI.P_orgUid]) {
        return CI.DV_orgMetadata[CI.P_orgUid]['name'];
      } else {
        return `Loading: ${CI.P_orgUid}`
      }

      return "Loading...";
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/labels/OrgNameLabel.vue